import React from 'react';
import { Filter, SelectInput, TextInput } from 'react-admin';
import { InputAdornment } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';

const LocationFilters = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        alwaysOn
        source="name"
        label="Location name"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon color="disabled" />
            </InputAdornment>
          ),
        }}
      />

      <TextInput
        alwaysOn
        source="city"
        label="City name"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon color="disabled" />
            </InputAdornment>
          ),
        }}
      />
    </Filter>
  );
};

export default LocationFilters;
